import { FrontSide } from "three";

// Keep the transparent cutaway separate from opaque engine depth. This is an
// XR-only override: source GLTF geometry and desktop material settings survive.
const ghostOrder = {
  xRay_Hybrid_AWD: 1, xRay_HybridMax: 1,
  body_biTone: 2, body_colorChange: 3, roof_XLE: 4, roof_Lim_Plat: 4,
  body_constant: 5,
};

export function applyXrPowertrainRendering(root) {
  const restore = [], materials = new Set();
  root.traverse(mesh => {
    if (!mesh.isMesh) return;
    if (mesh.name.startsWith("driveTrain_")) {
      // These exported engine meshes contain paired opposite-facing surfaces.
      // DoubleSide draws both at the same depth; preserve the source triangles
      // and cull the interior face instead of biasing the entire merged engine.
      const material = mesh.material, side = material.side;
      material.side = FrontSide;
      material.needsUpdate = true;
      restore.push(() => { material.side = side; material.needsUpdate = true; });
    }
    const order = ghostOrder[mesh.name];
    if (order === undefined) return;
    const oldOrder = mesh.renderOrder;
    mesh.renderOrder = order;
    restore.push(() => { mesh.renderOrder = oldOrder; });
    const material = mesh.material;
    if (materials.has(material)) return;
    materials.add(material);
    const previous = {
      depthWrite: material.depthWrite, polygonOffset: material.polygonOffset,
      polygonOffsetFactor: material.polygonOffsetFactor,
      polygonOffsetUnits: material.polygonOffsetUnits,
    };
    material.depthWrite = false;
    // Bias only the blue overlay, not the engine or the whole renderer. Keep
    // depth testing so hands and nearer engine parts still occlude it correctly.
    if (mesh.name.startsWith("xRay_")) {
      material.polygonOffset = true;
      material.polygonOffsetFactor = -1;
      material.polygonOffsetUnits = -1;
    }
    restore.push(() => Object.assign(material, previous));
  });
  return () => restore.forEach(undo => undo());
}
